import list from "@/layout/footerView/data/list";

export default {
    data() {
        return {
            linkList: [],
            list
        }
    },

    watch: {

    },

    created() {
        this.getLink();
    },

    methods: {

        // 获取友情链接
        getLink() {
            this.$post('api.php/Home/friendLink').then(res => {
                if(res.status == 1) {

                    this.linkList = res.data || []
                }
            })
        },

        openPage(item) {
            this.$router.push({
                name: item.url
            })
        },


        goPage() {
            window.open('https://beian.miit.gov.cn')
        },

        openLink(item) {
            let head = item.url.substring(0,4);
            if(head === 'http') {
                window.open(item.url)
            }else {
                window.open('http://' + item.url)
            }
        }
    }
}
